import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'local' ? `http://${window.location.hostname}:8080` : process.env.VUE_APP_URLS_API

export const storeClient = axios.create({ baseURL })
